import Routes from "./components/Routes";

function App() {
  return (
    <div>
      <Routes />
    </div>
  );
}

export default App;
